import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'img[appDefaultImage]'
})
export class DefaultImageDirective {
  appDefaultImage: string = 'assets/images/default-pic.png';

  @HostListener('error', ['$event']) onError(event: Event) {
    const element = (event.target as HTMLImageElement);
    if (element.src !== this.appDefaultImage) {
      element.src = this.appDefaultImage;
    }
  }
}
